import { PayloadAction } from '@reduxjs/toolkit';
import { ISelectedCheckout } from '../../core/interfaces/ISelectedCheckout';
import { ProductsType } from '../../ipaf/enums/ProductsType';

// Definimos el tipo del estado
export interface SelectedCheckoutState {
    checkouts: ISelectedCheckout[];
}


export const SelectedCheckoutReducer = {
    addSelectedCheckout: (
        state: SelectedCheckoutState,
        action: PayloadAction<ISelectedCheckout>
    ) => {
        // Removemos cualquier checkout existente del mismo tipo de producto
        state.checkouts = state.checkouts.filter(
            checkout => checkout.product !== action.payload.product
        );
        // Añadimos el nuevo checkout
        state.checkouts.push(action.payload);
    },
    
    removeSelectedCheckout: (
        state: SelectedCheckoutState,
        action: PayloadAction<ProductsType>
    ) => {
        state.checkouts = state.checkouts.filter(
            checkout => checkout.product !== action.payload
        );
    },
    
    clearSelectedCheckouts: (state: SelectedCheckoutState) => {
        state.checkouts = [];
    },
}; 